import request from "@/utils/request";

export default function getUserInfo(fromType,fromId) {
    return request({
        url: `/commonUser/getUserInfo/`+fromType+`/`+fromId,
        method: 'get',
    })
}